document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('.p-serviceDelay__imageWrap').forEach((wrap) => {
    const target =
      wrap.querySelector('[class*="__image"]:not([class*="imageWrap"])') ||
      wrap.firstElementChild;

    if (!target) return;

    const y = parseFloat(wrap.dataset.y) || -40;

    gsap.to(target, {
      yPercent: y,
      ease: 'none',
      scrollTrigger: {
        trigger: wrap,
        start: 'top bottom', // ← 画面に入った瞬間スタート
        end: 'top 20%',
        scrub: true,
        // markers: true,
      },
    });
  });
});
